const vueDialogDrag = {}
vueDialogDrag.install = Vue => {
  // v-dialogDrag: 弹窗拖拽
  Vue.directive('drag2anywhere', {
    bind(el, binding, vnode, oldVnode) {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      const dragDom = el.querySelector('.el-dialog')
      dialogHeaderEl.style.cursor = 'move'
      el.style.overflow = "hidden"
      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

      dialogHeaderEl.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - dialogHeaderEl.offsetLeft
        const disY = e.clientY - dialogHeaderEl.offsetTop
        // 获取可视区域
        const cliW = document.documentElement.clientWidth
        const cliH = document.documentElement.clientHeight
        // 获取到的值带px 正则匹配替换
        let styL, styT

        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (sty.left.includes('%')) {
          styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
          styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
        } else {
          styL = +sty.left.replace(/\px/g, '')
          styT = +sty.top.replace(/\px/g, '')
        }

        document.onmousemove = function (e) {

          // 通过事件委托，计算移动的距离
          let left = e.clientX - disX
          let top = e.clientY - disY

          // 移动当前元素 边界处理
          if ((disX + left > 100) && (disX + left + 100 < cliW)) {
            dragDom.style.left = `${left + styL}px`
          }
          if ((disY + top > 25) && (disY + top + 85 < cliH)) {
            dragDom.style.top = `${top + styT}px`
          }
        }

        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  })
}
export default vueDialogDrag



// WEBPACK FOOTER //
// ./src/utils/directive.js